module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content clearfix"
  }, [_c('div', {
    staticClass: "info-widgets clearfix"
  }, [_c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    attrs: {
      "stats": {
        title: 'Countries',
        stat: _vm.countries
      },
      "backgroundColor": "#00beee",
      "color": "#fff",
      "animate": "",
      "logo": "fa fa-globe"
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    attrs: {
      "stats": {
        title: 'Locations',
        stat: _vm.locations
      },
      "backgroundColor": "#02a85c",
      "logo": "fa fa-map-marker",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    attrs: {
      "stats": {
        title: 'Jobs',
        stat: _vm.jobs
      },
      "backgroundColor": "#f39c11",
      "logo": "fa fa-industry",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    attrs: {
      "stats": {
        title: 'Users',
        stat: _vm.users
      },
      "backgroundColor": "#f56854",
      "logo": "fa fa-user",
      "color": "#fff",
      "animate": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-eq-height p-15"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "big-chart"
    }
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('am-map', {
    attrs: {
      "mapData": _vm.mapData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-bar', {
    attrs: {
      "chartData": _vm.chartData,
      "categoryField": "Country",
      "valueField": "count"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "info-widgets clearfix"
  }, [_c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    attrs: {
      "stats": {
        title: 'Currencies',
        stat: _vm.currencies
      },
      "backgroundColor": "#f56854",
      "logo": "fa fa-usd",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    attrs: {
      "stats": {
        title: 'Parties',
        stat: _vm.parties
      },
      "backgroundColor": "#f39c11",
      "logo": "fa fa-address-book",
      "color": "#fff",
      "animate": ""
    }
  }), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'QUOTE')) ? _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "stats": {
        title: 'Quotes - Add New',
        stat: 'Go Now'
      },
      "backgroundColor": "#02a85c",
      "logo": "fa fa-plus-square",
      "color": "#fff"
    },
    on: {
      "clicked": function($event) {
        return _vm.$router.push({
          name: 'Add a new Quote'
        })
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasPermission(_vm.$store, 'QUOTE')) ? _c('info-widget', {
    staticClass: "col-xs-12 col-sm-6 col-md-3",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "stats": {
        title: 'Quotes - Batch Upload',
        stat: 'Go Now'
      },
      "backgroundColor": "#00beee",
      "color": "#fff",
      "logo": "fa fa-upload"
    },
    on: {
      "clicked": function($event) {
        return _vm.$router.push({
          name: 'Quote Batch Upload'
        })
      }
    }
  }, [_vm._v("\n      >\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('vue-table', {
    staticClass: "mai-panel",
    staticStyle: {
      "padding": "0 !important"
    },
    attrs: {
      "tableData": _vm.recentJobs,
      "fields": _vm.fields,
      "tableTitle": "Most recent 100 jobs"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Most recent 100 jobs "), _c('small', [_vm._v("- by destination country")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Most recent 100 jobs "), _c('small', [_vm._v("- by origin country")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7309f757"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 2228
// module chunks = 1